import { Component, OnInit, Optional, Injector, Inject } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { TranslateService } from '@ngx-translate/core';
// import { OktaAuthConfigService } from '../services/auth-config.serice';

@Component({
  selector: 'ciciam-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
  error: string = '';

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private translate: TranslateService,
    @Optional() private injector?: Injector
  ) {}

  async ngOnInit(): Promise<void> {
    // const config = this.configService.getConfig();
    // if (!config) {
    //   throw new Error('Okta config is not provided');
    // }
    try {
      await this.oktaAuth.handleLoginRedirect();
    } catch (e) {
      if (
        (e as Error).message &&
        (e as Error).message.includes('codeVerifier')
      ) {
        await this.oktaAuth.signInWithRedirect();
      } else {
        this.error = (e as Error).toString();
      }
    }
  }
}
